import { render, staticRenderFns } from "./LandingV3.vue?vue&type=template&id=1c3839e2&scoped=true&"
import script from "./LandingV3.vue?vue&type=script&lang=js&"
export * from "./LandingV3.vue?vue&type=script&lang=js&"
import style0 from "./LandingV3.vue?vue&type=style&index=0&id=1c3839e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3839e2",
  null
  
)

export default component.exports